















import {Component, Vue} from "vue-property-decorator";
import FilmList from "@/modules/Rhizome/components/FilmList.vue";
import {RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";
import RhizomeCloud from "@/modules/Rhizome/components/RhizomeCloud.vue";
import Header from "@/components/Header.vue";

@Component({
  components: {
    Header,
    FilmList,
    RhizomeCloud,
  }
})

export default class RhizomePage extends Vue {
  isLoading = true;
  mediaQuery: any = null;
  viewTypes = RhizomeViewType;

  get isMenuOpen() {
    return this.$store.state.dialog.menu;
  }
  get activeView(): RhizomeViewType {
    return this.$store.state.rhizome.viewType;
  }
  get isError(): boolean {
    return this.$store.state.rhizome.errorOnRequest;
  }
  set activeView(value: RhizomeViewType) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'viewType', value })
  }
  async created() {
    this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
    if (!this.$store.state.rhizome.filmsList.length) {
      try {
        await this.$store.dispatch('rhizome/initRhizome');
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: false });
      }
      catch (e) {
        console.log(e);
        this.$store.commit('rhizome/setPropertyInState', { name: 'errorOnRequest', value: true });
      }
    }
      this.isLoading = false;
  }
  mounted() {
    this.activeView = RhizomeViewType.CLOUD;
    this.mediaQuery = window.matchMedia("(max-width: 500px)");
    this.checkMedia(this.mediaQuery);
    this.mediaQuery.addListener(this.checkMedia);
  }
  checkMedia(e) {
    if (e.matches) {
      this.activeView = this.viewTypes.LIST;
    }
  }
  destroyed() {
    this.mediaQuery.removeListener(this.checkMedia);
  }
}
